/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    withRouter
} from 'react-router-dom';
/* Package JSON Import will be here */

/* Project Import will be here */
import CurrentWeekTimeCardComponent from './currentWeekTimeCard.Component';
import { ApiUrls } from '../../../services/api';
import * as moment from 'moment';
import Api from '../../../services/api/serviceCall';
import { Constants } from '../../../config/appConstants';
import { MessageBox } from '../../../scenes/sharedComponent/messageBox';
import * as onDefaultGroupByAction from '../../../actions/timecardDefaultGroupBy.Action';
import { bindActionCreators } from 'redux';
import { isEqual } from 'lodash';
import * as actions from '../../../actions/tmVoucher.Action';
import { EmptyAttestDetails, getAttestation } from '../Attestation/AttestationUtils';
import { replaceNullWithEmptyString } from '../../../services/utility';

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class CurrentWeekTimeCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isGroupByModelVisible: false,
            isIssueNotesModalVisible: false,
            isOpenTimeCardReview: false,
            issueNotesList: [],
            selectedAttachment: "",
            isAttachmentModelVisible: false,
            timeRecords: [],
            weekStartDate: null,
            weekEndingDate: null,
            selectedPayrollNote: "",
            isShowPunchesModal: false,
            isShowPayrollNoteModal: false,
            isShowActualNoteModal: false,
            defaultGroupBy: Constants.EMPLOYEE,
            isShowExpectationNoteModal: false,
            isOpenActualNotes: false,
            selectedActualNote: {},
            selectedTimeCardPunches: {},
            selectedExpectationNote: {},
            isShowLoader: false,
            fromDate: '',
            toDate: '',
            isShowTMVoucher: this.props.tmVoucherReducer.setTmVoucherModelVisibility ?? false,
            tmTaskCodeList: [],
            selectedTMVoucher: {},
            tmVoucherConfirmMessage: '',
            isAllowAttestation: false,
        }
    }

    componentWillMount() {
        window.addEventListener('beforeunload', () => {
            this.props.setTmVoucherModelVisibility(false);
        });
        let { defaultGroupBy } = this.state;
        if (this.props.groupBy.defaultGroupBy && this.props.groupBy.defaultGroupBy === Constants.EMPLOYEE) {
            defaultGroupBy = this.props.groupBy.defaultGroupBy;
        }
        var current = new Date();
        var monday = (new Date(current.setDate(current.getDate() - current.getDay() + (current.getDay() == 0 ? -6 : 1))));
        var sunday = (new Date(current.setDate(current.getDate() - current.getDay() + 7)));
        this.setState({
            weekEndingDate: sunday, weekStartDate: monday, defaultGroupBy
        }, () => {
            this.getTimeCardData();
            this.getTMVoucherTaskCodes();
        });
    }

    getTimeCardData() {
        let { defaultGroupBy, weekStartDate, weekEndingDate, timeRecords } = this.state;

        var startTime = new Date(weekStartDate.setHours(0, 0, 0));
        var startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        var tomorrow = new Date(weekEndingDate);
        var endTime = tomorrow.setDate(tomorrow.getDate() + 1);
        var endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        var dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        var selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
        var selectedDate = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);
        var timeZone = startDate.toString();
        var selectTimeZone = timeZone.slice(16, 24);
        var fromDate = `${selectDate} ${selectTimeZone}`;
        var toDate = `${selectedDate} ${selectTimeZone}`;
        timeRecords = [];
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_TME_CRD_DTE_RNG}?fromDate=${fromDate}&toDate=${toDate}&deviceId=${this.props.device.deviceId}&isSubmittedOnly=${false}&isFetchAllStatus=${true}`;
        Api.Get(url, this).then(responseData => {
            if (responseData.success) {
                this.setState({ isAllowAttestation: responseData.data.isAllowAttestation });
                var timeRecordData = responseData.data.timecardList;
                timeRecordData.sort((a, b) => (a.createdDate < b.createdDate) ? -1 : 1);
                if (defaultGroupBy == Constants.DATE) {
                    var groupByDate = timeRecordData.reduce((prev, curr) => {
                        if (curr.projectNumber) {
                            var previousData = prev.find(a => a.date == moment(curr.createdDate).format('MM/DD/YYYY'));
                            if (prev && previousData) {
                                previousData.timecardData = [...previousData.timecardData || [], curr];
                                previousData.totalStHours = Number(previousData.totalStHours) + Number(curr.stHours ? curr.stHours : 0);
                                previousData.totalOtHours = Number(previousData.totalOtHours) + Number(curr.otHours ? curr.otHours : 0);
                                previousData.totalDtHours = Number(previousData.totalDtHours) + Number(curr.dtHours ? curr.dtHours : 0);
                            }
                            else {
                                prev.push({
                                    employeeName: curr.fullName,
                                    employeeID: curr.employeeID,
                                    date: moment(curr.createdDate).format('MM/DD/YYYY'),
                                    timecardData: [curr],
                                    totalStHours: Number(curr.stHours ? curr.stHours : 0),
                                    totalOtHours: Number(curr.otHours ? curr.otHours : 0),
                                    totalDtHours: Number(curr.dtHours ? curr.dtHours : 0)
                                });
                            }
                            return prev;
                        }
                        else {
                            prev = [];
                            return prev;
                        }
                    }, []);

                    for (var groupdata of groupByDate) {
                        let groupByFunc = () => {
                            return groupdata.timecardData.reduce((prev, curr) => {
                                var previousData = prev.find(a => a.employeeID == curr.employeeID);
                                if (prev && previousData) {
                                    previousData.timecardData = [...previousData.timecardData || [], curr];
                                    previousData.totalStHours = Number(previousData.totalStHours) + Number(curr.stHours ? curr.stHours : 0);
                                    previousData.totalOtHours = Number(previousData.totalOtHours) + Number(curr.otHours ? curr.otHours : 0);
                                    previousData.totalDtHours = Number(previousData.totalDtHours) + Number(curr.dtHours ? curr.dtHours : 0);
                                }
                                else {
                                    prev.push({
                                        date: moment(curr.createdDate).format('MM/DD/YYYY'),
                                        employeeName: curr.fullName,
                                        employeeID: curr.employeeID,
                                        timecardData: [curr],
                                        totalStHours: Number(curr.stHours ? curr.stHours : 0),
                                        totalOtHours: Number(curr.otHours ? curr.otHours : 0),
                                        totalDtHours: Number(curr.dtHours ? curr.dtHours : 0)
                                    });
                                }
                                return prev;
                            }, []);
                        }

                        groupdata.timecardData = groupByFunc();
                        groupdata.groupBy = Constants.DATE;
                        timeRecords.push(groupdata);
                    }
                    this.setState({
                        timeRecords,
                        fromDate: fromDate,
                        toDate: toDate
                    });

                } else {
                    var groupByName = timeRecordData.reduce((prev, curr) => {
                        if (curr.employeeID) {
                            var previousData = prev.find(a => a.employeeID == curr.employeeID);
                            if (prev && previousData) {
                                previousData.timecardData = [...previousData.timecardData || [], curr];
                                previousData.totalStHours = Number(previousData.totalStHours) + Number(curr.stHours ? curr.stHours : 0);
                                previousData.totalOtHours = Number(previousData.totalOtHours) + Number(curr.otHours ? curr.otHours : 0);
                                previousData.totalDtHours = Number(previousData.totalDtHours) + Number(curr.dtHours ? curr.dtHours : 0);
                                previousData.timeRecordIds = [...previousData.timeRecordIds || [], curr.timeRecordID];
                            }
                            else {
                                prev.push({
                                    employeeName: curr.fullName,
                                    employeeID: curr.employeeID,
                                    employeeNumber: curr.employeeNumber,
                                    timeRecordIds: [curr.timeRecordID],
                                    date: moment(curr.createdDate).format('MM/DD/YYYY'),
                                    timecardData: [curr],
                                    totalStHours: Number(curr.stHours ? curr.stHours : 0),
                                    totalOtHours: Number(curr.otHours ? curr.otHours : 0),
                                    totalDtHours: Number(curr.dtHours ? curr.dtHours : 0),
                                    groupBy: Constants.EMPLOYEE
                                });
                            }
                            return prev;
                        }
                        else {
                            prev = [];
                            return prev;
                        }
                    }, []);

                    this.setState({
                        timeRecords: groupByName,
                        fromDate: selectDate,
                        toDate: selectedDate
                    });
                }
            }
        });
    }

    onClickTimeCardReview() {
        this.setState({
            isOpenTimeCardReview: true
        });
    }

    closeIssueNotes(issue) {
        this.setState({
            isIssueNotesModalVisible: false
        })
    }

    onCloseTimeCardReview() {
        this.setState({
            isOpenTimeCardReview: false
        })
    }

    openOrClosePunchesModal = notes => {
        let { selectedTimeCardPunches } = this.state;
        if (notes.isShowPunchesModal) {
            selectedTimeCardPunches = {
                startTime: replaceNullWithEmptyString(notes.selectedTimeCardPunches.startTime),
                lunchStartTime: replaceNullWithEmptyString(notes.selectedTimeCardPunches.lunchStartTime),
                lunchEndTime: replaceNullWithEmptyString(notes.selectedTimeCardPunches.lunchEndTime),
                endTime: replaceNullWithEmptyString(notes.selectedTimeCardPunches.endTime),
            }
            this.setState({ isShowPunchesModal: notes.isShowPunchesModal, selectedTimeCardPunches });
        } else {
            this.setState({ isShowPunchesModal: false, selectedTimeCardPunches: {} });
        }
    }

    openOrCloseExpectationNoteModel = notes => {
        let { timeRecords, defaultGroupBy, selectedExpectationNote } = this.state;
        let selectedNote;
        if (notes.modalOpenExceptationalNote) {
            if (defaultGroupBy == Constants.DATE) {
                selectedNote = timeRecords[notes.rowIndex].timecardData[notes.index].timecardData[notes.empIndex];
            }
            else {
                selectedNote = timeRecords[notes.index].timecardData[notes.empIndex];
            }
            selectedExpectationNote = {
                expectationUnits: selectedNote.expectationUnits,
                expectationNote: selectedNote.expectationNote
            }
            this.setState({
                isShowExpectationNoteModal: notes.modalOpenExceptationalNote, selectedExpectationNote
            });
        }
        else {
            this.setState({ isShowExpectationNoteModal: false, selectedExpectationNote: {} });
        }
    }

    openOrClosePayrollNoteModel = notes => {
        let { timeRecords, defaultGroupBy, selectedPayrollNote } = this.state;
        let selectedNote;
        if (notes.modalOpenPayRollNote) {
            if (defaultGroupBy == Constants.DATE) {
                selectedNote = timeRecords[notes.rowIndex].timecardData[notes.index].timecardData[notes.empIndex];
            }
            else {
                selectedNote = timeRecords[notes.index].timecardData[notes.empIndex];
            }

            selectedPayrollNote = selectedNote.payrollNote;
            this.setState({
                isShowPayrollNoteModal: notes.modalOpenPayRollNote, selectedPayrollNote
            });
        }
        else {
            this.setState({ isShowPayrollNoteModal: false, selectedPayrollNote: "" });
        }
    }

    onClickGrpByModel() {
        this.setState({
            isGroupByModelVisible: true
        });
    }
    onCloseGrpByModel() {
        this.setState({
            isGroupByModelVisible: false
        });
    }

    onChangeGroupByOption = (groupBy) => {
        let { defaultGroupBy } = this.state;
        switch (groupBy) {
            case Constants.DATE:
                defaultGroupBy = groupBy;
                break;
            case Constants.EMPLOYEE:
                defaultGroupBy = groupBy;
                break;
        }
        this.props.onDefaultGroupBy(defaultGroupBy);
        this.setState({ defaultGroupBy: groupBy, isGroupByModelVisible: false }, () => {
            this.getTimeCardData();
        });
    }

    onClickBack() {
        this.props.history.goBack();
    }

    onClickCurrentWeekTimeCard() {
        // let { isOpenTimeCardReview } = this.state;
        // this.props.history.push("/CurrentWeekTimeCard");
        this.setState({
            isOpenTimeCardReview: false
        }, () => {
            this.getTimeCardData();
        });
    }

    onClickPreviousWeekTimeCard() {
        this.props.history.push("/PreviousWeekTimeCard");
    }

    openNotes = notes => {
        let { timeRecords, defaultGroupBy, selectedActualNote } = this.state;
        let selectedNote;

        if (defaultGroupBy == Constants.DATE) {
            selectedNote = timeRecords[notes.rowIndex].timecardData[notes.index].timecardData[notes.empIndex];
        }
        else {
            selectedNote = timeRecords[notes.index].timecardData[notes.empIndex];
        }

        if (notes.modalOpenActualNote) {
            let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_ATCHMT_BY_TMC_ID_M}?timeRecordId=${selectedNote.timeRecordID}&deviceId=${this.props.device.deviceId}`;
            Api.Get(url, this,true,true).then(response => {
                if (response.success) {
                    let attachmentLists = [];
                    if (response.data.length > 0) {
                        response.data.map((attach, index) => {
                            attachmentLists.push({
                                id: attach.id,
                                attachmentType: attach.attachmentType,
                                attachmentName: attach.attachmentName,
                                attachmentContent: attach.attachmentContent
                            });
                        });
                    }
                    selectedActualNote = {
                        timeRecordID: notes.timeCardId,
                        deviceID: notes.deviceId,
                        actualUnits: selectedNote && selectedNote.workUnits ? selectedNote.workUnits : '',
                        actualNote: selectedNote && selectedNote.workNote ? selectedNote.workNote : '',
                        attachments: attachmentLists
                    }
                    this.setState({
                        isOpenActualNotes: notes.modalOpenActualNote, selectedActualNote, isShowLoader: false
                    });
                }
                else {
                    this.setState({ isOpenActualNotes: false, selectedActualNote: {}, isShowLoader: false });
                }
            });

        }
    }

    onClickActualNoteBack() {
        this.setState({
            isOpenActualNotes: false
        })
    }

    openAttachmentViewer(attachment) {
        this.setState({
            isAttachmentModelVisible: true,
            selectedAttachment: attachment
        });
    }

    closeAttachmentViewer() {
        this.setState({
            isAttachmentModelVisible: false,
            selectedAttachment: ""
        });
    }

    getTimeCardIssue() {
        let { weekStartDate, weekEndingDate } = this.state;

        var startTime = new Date(weekStartDate.setHours(0, 0, 0));
        var startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        var tomorrow = new Date(weekEndingDate);
        var endTime = tomorrow.setDate(tomorrow.getDate() + 1);
        var endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        var dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        var selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
        var selectedDate = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);
        var timeZone = startDate.toString();
        var selectTimeZone = timeZone.slice(16, 24);
        var fromDate = `${selectDate} ${selectTimeZone}`;
        var toDate = `${selectedDate} ${selectTimeZone}`;


        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_ISE_NT_M}?fromDate=${fromDate}&toDate=${toDate}&deviceId=${this.props.device.deviceId}&isSubmittedOnly=${false}&isFetchAllStatus=${true}`;
        Api.Get(url, this,true,true).then(responseData => {
            if (responseData.success) {
                this.setState({
                    isIssueNotesModalVisible: true, issueNotesList: responseData.data, isShowLoader: false
                });
            } else {
                this.setState({ isShowLoader: false });
                MessageBox(responseData.message, Constants.ERROR);
            }
        });
    }

    onClickDailyDetails = () => {
        let { weekStartDate, weekEndingDate } = this.state;
        var startTime = new Date(weekStartDate.setHours(0, 0, 0));
        var startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        var tomorrow = new Date(weekEndingDate);
        var endTime = tomorrow.setDate(tomorrow.getDate() + 1);
        var endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        var dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        var selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
        var selectedDate = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);
        var timeZone = startDate.toString();
        var selectTimeZone = timeZone.slice(16, 24);
        var fromDate = `${selectDate} ${selectTimeZone}`;
        var toDate = `${selectedDate} ${selectTimeZone}`;
        this.props.history.push('DailyDetails', { fromDate: fromDate, toDate: toDate, isAllowToEdit: false });
    }

    onClickTMVoucherBtn() {
        this.props.setTmVoucherModelVisibility(true);
        this.setState({ isShowTMVoucher: true });
    }

    onClickTMVoucherBackBtn() {
        this.props.setTmVoucherModelVisibility(false);
        const { selectedTMVoucher } = this.state;
        isEqual(selectedTMVoucher, {}) ? this.setState({ isShowTMVoucher: false, selectedTMVoucher: {} }) : this.setState({ isShowTMVoucher: false, selectedTMVoucher: {} });
    }
    onChangeSelectTaskCode(taskCode) {
        this.setState({ selectedTMVoucher: taskCode });
    }

    getTMVoucherTaskCodes() {
        let { weekStartDate, weekEndingDate } = this.state;
        let startTime = new Date(weekStartDate.setHours(0, 0, 0));
        let startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        let tomorrow = new Date(weekEndingDate);
        let endTime = tomorrow.setDate(tomorrow.getDate() + 1);
        let endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        let dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        let selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
        let dateSelected = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);
        let timeZone = startDate.toString();
        let selectTimeZone = timeZone.slice(16, 24);
        let url = `${ApiUrls.Routes.TM_VCHR_C}${ApiUrls.Routes.GT_TM_VCHR_PRJ_TK_LT_M}?fromDate=${selectDate}@${selectTimeZone}&&toDate=${dateSelected}@${selectTimeZone}&deviceId=${this.props.device.deviceId}`;
        Api.Get(url, this).then((response) => {
            if (response.success) {
                if (response.data && response.data.length > 0) {
                    this.setState({ tmTaskCodeList: response.data });
                }
            } else {
                MessageBox(response.message, Constants.ERROR);
            }
        });
    }

      onClickSelectBtn() {
        const { selectedTMVoucher } = this.state;
        if (isEqual(selectedTMVoucher, {})) {
            MessageBox(Constants.PLEASE_SELECT_TASK_CODE, Constants.ERROR);
        } else {
            this.props.history.push("/TMVoucherPDFViewer", {selectedTMVoucher});
        }
    }

    async openAttestation(timeRecordId, timeCardStatus) {
        const { timeRecords } = this.state;
        const records = timeRecords.map(t => t.timecardData).flat();
        const selectedRecord = records.find(t => t.timeRecordID === timeRecordId);
        const attestationPDF = selectedRecord?.attachmentContent ?? null;
        const url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_ATTST_BTMCRD_ID_M}?deviceId=${this.props.device.deviceId}&timeRecordId=${timeRecordId}&isFetchAllStatus=${true}`;
        const attestationDetails = await getAttestation(url, timeRecords, timeRecordId, this);
        const isSubmittedAttestation = timeCardStatus !== Constants.IN_PROGRESS || attestationPDF !== null;
        this.props.history.push("Attestation", { timeRecords, attestationDetails, isSubmittedAttestation, attestationPDF, isFromWeekTimeCard: true });
    }

    render() {
        const { timeRecords,
            isGroupByModelVisible,
            isOpenTimeCardReview,
            issueNotesList,
            isIssueNotesModalVisible,
            isAttachmentModelVisible,
            selectedAttachment,
            weekEndingDate,
            weekStartDate,
            isShowPunchesModal,
            selectedPayrollNote,
            isShowPayrollNoteModal,
            isShowActualNoteModal,
            defaultGroupBy,
            isShowExpectationNoteModal,
            selectedActualNote,
            isOpenActualNotes,
            selectedTimeCardPunches,
            selectedExpectationNote,
            isShowLoader,
            isShowTMVoucher,
            tmTaskCodeList,
            selectedTMVoucher,
            tmVoucherConfirmMessage,
            isAllowAttestation,
        } = this.state;
        return (
            <Fragment>
                <CurrentWeekTimeCardComponent
                    {...{
                        timeCard: {
                            isOpenTimeCardReview,
                            isGroupByModelVisible,
                            isIssueNotesModalVisible,
                            issueNotesList,
                            isAttachmentModelVisible,
                            selectedAttachment,
                            weekEndingDate,
                            weekStartDate,
                            timeRecords,
                            isShowPunchesModal,
                            isShowPayrollNoteModal,
                            selectedPayrollNote,
                            isShowActualNoteModal,
                            defaultGroupBy,
                            selectedActualNote,
                            isOpenActualNotes,
                            isShowExpectationNoteModal,
                            selectedTimeCardPunches,
                            selectedExpectationNote,
                            isShowLoader,
                            isShowTMVoucher,
                            tmTaskCodeList,
                            selectedTMVoucher,
                            tmVoucherConfirmMessage,
                            isAllowAttestation
                        }
                    }}
                    getTimeCardIssue={this.getTimeCardIssue.bind(this)}
                    onClickTimeCardReview={this.onClickTimeCardReview.bind(this)}
                    onClickGrpByModel={this.onClickGrpByModel.bind(this)}
                    closeIssueNotes={this.closeIssueNotes.bind(this)}
                    onCloseTimeCardReview={this.onCloseTimeCardReview.bind(this)}
                    onCloseGrpByModel={this.onCloseGrpByModel.bind(this)}
                    onChangeGroupByOption={this.onChangeGroupByOption.bind(this)}
                    onClickBack={this.onClickBack.bind(this)}
                    onClickCurrentWeekTimeCard={this.onClickCurrentWeekTimeCard.bind(this)}
                    onClickPreviousWeekTimeCard={this.onClickPreviousWeekTimeCard.bind(this)}
                    openNotes={this.openNotes.bind(this)}
                    onClickActualNoteBack={this.onClickActualNoteBack.bind(this)}
                    openAttachmentViewer={this.openAttachmentViewer.bind(this)}
                    openOrClosePunchesModal={this.openOrClosePunchesModal.bind(this)}
                    openOrClosePayrollNoteModel={this.openOrClosePayrollNoteModel.bind(this)}
                    openOrCloseExpectationNoteModel={this.openOrCloseExpectationNoteModel.bind(this)}
                    closeAttachmentViewer={this.closeAttachmentViewer.bind(this)}
                    onClickDailyDetails={this.onClickDailyDetails.bind(this)}
                    onClickTMVoucherBtn={this.onClickTMVoucherBtn.bind(this)}
                    onClickTMVoucherBackBtn={this.onClickTMVoucherBackBtn.bind(this)}
                    onChangeSelectTaskCode={this.onChangeSelectTaskCode.bind(this)}
                    onClickSelectBtn={this.onClickSelectBtn.bind(this)}
                    openAttestation={this.openAttestation.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user,
        device: state.deviceReducer.device,
        groupBy: state.defaultGroupByReducer.groupBy,
        tmVoucherReducer: state.tmVoucherReducer.selectedTMVouchers
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            onDefaultGroupByAction, actions),
        dispatch);
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CurrentWeekTimeCard));

CurrentWeekTimeCard.displayName = 'CurrentWeekTimeCard';